import SvgIcon from "@mui/material/SvgIcon";

interface HectaresIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function HectaresIcon({
  htmlColor,
  fontSize = "medium",
}: HectaresIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize}>
      <path
        d="M6.41602 1.16666H5.24935C2.33268 1.16666 1.16602 2.33332 1.16602 5.24999V8.74999C1.16602 11.6667 2.33268 12.8333 5.24935 12.8333H8.74935C11.666 12.8333 12.8327 11.6667 12.8327 8.74999V7.58332"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
